module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud01_m.7aa7a50f4f988c9f6ba175d1a5e0c969.png";